import { createListenerMiddleware } from "@reduxjs/toolkit";
import { appRehydratedListener } from "Data/Redux/Middleware/Listener/System";
import type { AppState } from "Data/Redux/Reducers";

const listenerMiddleware = createListenerMiddleware<AppState>();

[
	appRehydratedListener
].forEach((listener) => {
	listener(listenerMiddleware);
});

export default listenerMiddleware;
